'use client';

import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { copy } from '@/data/copy';
import { clientLogout } from '@/lib/clientLogout';
import SpinningIcon from '@/components/icons/SpinningIcon';
import Logout from '@/components/icons/Logout';

export default function FinishLoggedSessionButton() {
  const [loading, setLoading] = useState(false);

  async function handleSignOut() {
    setLoading(true);
    await clientLogout();
  }

  return (
    <Button onClick={() => handleSignOut()} disabled={loading}>
      {loading ? <SpinningIcon /> : <Logout />}
      {loading
        ? copy.common.form.loggingOut
        : copy.pages.notFound.finishSession}
    </Button>
  );
}
